module.exports = __webpack_public_path__ + "img/4-low.e8dd70c4.jpg";